import { adminFullPartnersListSlice } from './adminFullPartnersList';
import { authSlice } from './auth';
import { crmResetPasswordSlice } from './crmResetPassword';
import { currencyRatesSlice } from './currencyRates';
import { customerJourneySlice } from './customerJourney';
import { dynamicSegmentSlice } from './dynamicSegment';
import { headerSlice } from './header';
import { maintenanceSlice } from './maintenance';
import { pageValidationSlice } from './pageValidation';
import { partnerLanguagesSlice } from './partnerLanguages';
import { partnerSettingsSlice } from './partnerSettings';
import { queryConfigurationsSlice } from './queryConfigurations';
import { reportColumnsSlice } from './reportColumns';
import { routeLeaveConfirmationSlice } from './routeLeaveConfirmation';
import { subscriptionPlansSlice } from './subscriptionPlans';
import { templateSlice } from './template';
import { userDataSlice } from './userData';
import { whatsAppTemplateSlice } from './whatsAppTemplate';

export const slicesList = [
    adminFullPartnersListSlice,
    authSlice,
    crmResetPasswordSlice,
    currencyRatesSlice,
    customerJourneySlice,
    dynamicSegmentSlice,
    headerSlice,
    maintenanceSlice,
    pageValidationSlice,
    partnerLanguagesSlice,
    partnerSettingsSlice,
    queryConfigurationsSlice,
    reportColumnsSlice,
    routeLeaveConfirmationSlice,
    subscriptionPlansSlice,
    templateSlice,
    userDataSlice,
    whatsAppTemplateSlice,
] as const;
